<script>
import MainContentBanner from '@/views/MainContentBanner.vue'
import bus from 'vue3-eventbus'
import Share from '@/views/Share.vue'
import ShareTipDialog from '@/components/dialog/ShareTipDialog.vue'

import lottie from 'lottie-web'
import coin from '@/assets/coins-sy.json'
import http from '@/utils/http'

export default {
  components: {
    ShareTipDialog,
    Share,
    MainContentBanner
  },
  computed: {
    rotateStyle () {
      return {
        transform: `rotate(${this.rotation}deg)`,
        transformOrigin: 'center center',
        transition: this.enableTransition ? 'transform 2s linear' : 'none'
      }
    },
    scaleStyle () {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'center center'
      }
    },

    indexData() {
      return this.$store.state.indexData
    },

    showV2Task() {
      return this.indexData?.show_task_icon_v2 || false
    },

    hasClaimTask() {
      return this.indexData?.hasClaimTaskRewards || false
    },

    progress() {
      const finished = this.indexData?.roundFinishedTasks || 0
      const total = this.indexData?.roundTotalTasks || 0

      if (total <= 0) {
        return 0
      }

      return Math.floor((finished * 100) / total)
    },

    round() {
      return this.indexData?.taskRound || 1
    },

    countdownText () {

      const hours = Math.floor(this.remainSeconds / 3600)

      const minutes = Math.floor(
        (this.remainSeconds % 3600) / 60
      )

      const seconds = this.remainSeconds % 60

      return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`
    },

    expiredSecond () {
      return this.indexData?.expiredSecond || 0
    },
    showShareTips () {
      return this.$store.state.shareTip
    }
  },
  watch: {

    // 监听 computed
    expiredSecond: {

      immediate: true,

      handler (val) {

        this.startCountdown(val)

      }

    }

  },
  data () {
    return {
      scale: 1,
      rotation: 0,
      enableTransition: true,
      timer: null,
      remainSeconds: 0
    }
  },
  methods: {
    showTask () {
      bus.emit('main_task', true)
    },

    startAnimation () {
      // 1. div 从小到大缩放
      this.scale = 0.2
      setTimeout(() => {
        this.scale = 1
      }, 500) // 缩放动画完成的时间
      // 2. div 缩放完成后，开始旋转图片
      setTimeout(() => {
        this.enableTransition = true // 禁用旋转动画
        this.rotation = 1080 // 旋转3圈 (3 * 360 degrees)
      }, 2000) // 缩放动画完成的时间

      // 3. 旋转完成后，暂停 3 秒，然后重置动画
      setTimeout(() => {
        this.enableTransition = false // 禁用旋转动画
        this.rotation = 0 // 重置旋转

        setTimeout(this.startAnimation, 3000) // 暂停3秒后重新开始动画
      }, 4000)
    },

    startCountdown (seconds) {

      // 清理旧timer
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }

      this.remainSeconds = seconds

      if (seconds <= 0) {
        return
      }

      this.timer = setInterval(() => {

        if (this.remainSeconds > 0) {

          this.remainSeconds--

        } else {

          clearInterval(this.timer)
          this.timer = null

        }

      }, 1000)

    },

    pad (num) {
      return String(num).padStart(2, '0')
    },

    dismiss () {
      if (this.$route.path === '/main/earn_cash/0') {
        this.$store.commit('shareTip', false)
      } else {
        this.$router.push('/main/earn_cash/0')
      }
    },

    // 从引导 popup 进首页时（index.html?guide=newcomer|withdraw|invite），弹对应的弹窗/提示
    handleGuideEntry () {
      const url = new URL(window.location.href)
      const guide = url.searchParams.get('guide')
      if (!guide) return
      // 用掉即移除，避免路由来回时重复触发
      url.searchParams.delete('guide')
      window.history.replaceState(null, '', url.pathname + url.search + url.hash)

      if (guide === 'invite') {
        this.$store.commit('shareTip', true)
      } else if (guide === 'withdraw') {
        this.$store.commit('withdrawTip', true)
      } else if (guide === 'newcomer') {
        // 打开新手任务弹窗（AppMain 监听 main_task）
        bus.emit('main_task', true)
      }
    }
  },
  mounted () {
    http.reportEvent("us_earn_page_show","")
    this.handleGuideEntry()
    this.$watch(
      () => this.$route.params,
      () => {
        if (this.$route.params === 1) {
          if (!this.$store.state.shareTip) {
            this.$store.commit('shareTip', true)
          }
        }
      },
      { immediate: true }
    )
    this.startAnimation()

    this.anim2 = lottie.loadAnimation({
      container: this.$refs.coinRef,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData:coin                   
    })
  }
}

</script>

<template>
  <div id="earn_cash_page">
    <div id="banner">
      <MainContentBanner/>
    </div>
    <Share/>
    <div ref="coinRef" class="share-outline"></div>
  </div>
  <div class="task_actions">
    <!-- <div class="task_all" :style="scaleStyle">
      <img class="main-task-light" src="@/assets/task_float_light.png" :style="rotateStyle">
      <img class="main-task-icon" src="@/assets/main_task_icon.png" @click="showTask">
    </div> -->
    <div v-if="showV2Task" class="box_wrap"  @click="showTask">
      <div :class="`box-${round}`"></div>
      <div class="box-label">
        <span>${{round==1?8:10}}</span>
      </div>
      <div v-if="!hasClaimTask" class="level_progress_container">
        <div class="level_progress" :style="{ width: progress + '%' }"></div>
      </div>
      <div v-if="!hasClaimTask" class="expire-time">{{ countdownText  }}</div>
      <div v-if="hasClaimTask" class="claim"></div>
      <div class="box-base"></div>
    </div>
  </div>
  <div v-if="showShareTips" class="invite-tip-wrap">
    <ShareTipDialog/>
  </div>
</template>

<style scoped>

.dialog_contain {
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  z-index: 50;
  top: 0;
  justify-content: center;
}

#earn_cash_page {
  width: 104.8rem;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 邀请提示气泡：无遮罩，浮在 banner 与 EARN CASH 之间，指向分享区 */
.invite-tip-wrap {
  position: absolute;
  top: 28rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
}

#banner {
  width: 104.8rem;
  height: 35rem;
  overflow: hidden;
  border-radius: 1.6rem;
}

.task_actions {
  position: absolute;
  z-index: 1;
  right: 3rem;
  top: 22.8rem;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.task_all {
  width: 20rem;
  height: 20rem;
  transition: transform 0.5s ease; /* div 缩放动画 */
}

.main-task-light {
  width: 17rem;
  height: 16rem;
  position: absolute;
  right: 0;
  z-index: 1;
}

.main-task-icon {
  width: 9rem;
  height: 9rem;
  position: absolute;
  right: 3rem;
  z-index: 1;
  top: 3.2rem;
}

.main-task-icon:active {
  opacity: 0.6;
}

.box_wrap {
  width: 15rem;
  height: 15.5rem;
  position: absolute;
  right: 3rem;
  z-index: 1;
  margin-top: 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
}

.box-1 {
  width: 12.2rem;
  height: 9.3rem;
  background-image: url("@/assets/ic_box1.png");
  background-size: 100% 100%;
  z-index: 1;
  transform-origin: center center;

  animation: xSwing 1.2s infinite ease-in-out;
}

.box-2 {
  width: 12.2rem;
  height: 9.3rem;
  background-image: url("@/assets/ic_box2.png");
  background-size: 100% 100%;
  z-index: 1;
  transform-origin: center center;

  animation: xSwing 1s infinite ease-in-out;
}

@keyframes xSwing {
  0% {
    transform: rotate(10deg);
  }

  25% {
    transform: rotate(-10deg);
  }

  50% {
    transform: rotate(10deg);
  }

  75% {
    transform: rotate(-10deg);
  }

  100% {
    transform: rotate(10deg);
  }
}

.box-base {
  width: 11.1rem;
  height: 4.4rem;
  background-image: url("@/assets/ic_box_base.png");
  background-size: 100% 100%;
  margin-top: -2rem;
}

.box-label {
  width: 6.8rem;
  height: 4.1rem;
  background-image: url("@/assets/ic_box_label.png");
  background-size: 100% 100%;
  position: absolute;
  z-index: 2;
  top: 3rem;
  left: 0rem;
  font-size: 1.6rem;
  color: #FFF022;
  align-items: center;
  justify-items: center;
  display: flex;
  font-weight: 600;
  text-align: center;
}
.box-label span {
  display: inline-block;
  transform: rotate(-15deg);
  margin-left: 2rem;
  margin-bottom: 0.5rem;
}


.level_progress_container {
  background: #333333;
  width: 8.4rem;
  height: 1.3rem;
  display: flex;
  justify-content: center;
  align-content: center;
  position: absolute;
  z-index: 2;
  bottom: 7rem;
  border-radius: 1.3rem;
}

.level_progress {
  background: #0ED60D;
  height: inherit;
  border-radius: 1.3rem;
  position: absolute;
  left: 0;
  z-index: 3;
}

.expire-time {
  width: 100%;
  height: auto;
  color: #fff;
  font-size: 1.8rem;
  font-weight: 800;
  bottom: 4rem;
  text-align: center;
  position: absolute;
  z-index: 2;
}


.claim {
  width: 9.4rem;
  height: 3rem;
  background-image: url("@/assets/ic_box_claim.png");
  background-size: 100% 100%;
  position: absolute;
  z-index: 2;
  bottom: 3rem;
}

.share-outline {
  width: 85%;
  height: 80%;
  /* background-image: url("@/assets/main_share_outline.png");
  background-size: 100% 100%; */
  position: absolute;
  pointer-events: none;
  bottom: 0;
  left: 15%;
  top: 35%;
  z-index: 10;
}
</style>
